import React from "react";

const Footer = () => {
  return (
    <div className="p-20 text-white font-thin text-center">
      <p>
        <a href="https://portfolio-nine-silk-97.vercel.app/">
          © <b>Expense tracker</b>
        </a>
        . All rights reserved
      </p>
    </div>
  );
};

export default Footer;
